import React, { useState } from "react";

export default function Les3() {
  const acc = { user: ``, pass: `` };
  const [Account, setAccount] = useState(acc);
  const [AccountList, setAccountList] = useState([]);
  return (
    <div>
      <p>Logs... {JSON.stringify(AccountList)}</p>
      <form>
        <input
          type="text"
          placeholder="Username"
          value={Account.user}
          onChange={(e) => {
            e.preventDefault();
            setAccount({ ...Account, user: e.target.value });
          }}
        />
        <br />
        <input
          type="text"
          placeholder="Password"
          value={Account.pass}
          onChange={(e) => {
            e.preventDefault();
            setAccount({ ...Account, pass: e.target.value });
          }}
        />
        <br />
        <button
          onClick={(e) => {
            e.preventDefault();
            setAccountList([
              ...AccountList,
              { ...Account, index: AccountList.length },
            ]);
          }}
        >
          SetArr
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            setAccount(acc);
            setAccountList([]);
          }}
        >
          Clear
        </button>
      </form>
      <ul>
        {AccountList.map((item) => (
          <li key={item.index}>{`User: ${item.user} Pass: ${item.pass}`}</li>
        ))}
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// src/page/les3.js